import InputField from "components/fields/InputField";
import Default from "layouts/auth/types/Default";

function ForgotPasswordDefault() {
  return (
    <Default
      back="/auth/signin"
      maincard={
        <div className="w-full max-w-full flex-col items-center">
          {/* Sign in section */}
          <h2 className="mb-2 text-4xl font-bold text-navy-700 dark:text-white">
            Forgot Password?
          </h2>
          <p className="mt-[10px] ml-1 mb-8 text-base text-gray-600">
            No problem. Just let us know your email address and we'll email
            you a password reset link that will allow you to choose a new one.
          </p>
          {/* Email */}
          <InputField
            variant="auth"
            label="Email"
            placeholder="Your email"
            id="email"
            type="text"
          />
          {/* button */}
          <button className="mt-4 w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-800 dark:text-white dark:hover:bg-brand-700 dark:active:bg-brand-600">
            Email reset link
          </button>
        </div>
      }
    />
  );
}

export default ForgotPasswordDefault;
